const alignLeft = (containerGeom, elmGeom) => {
  return {
    left: containerGeom.offset.left,
    top: elmGeom.offset.top
  };
};

const alignHorizontally = (containerGeom, elmGeom) => {
  const elmShift = elmGeom.size.width / 2;
  const midPoint = containerGeom.offset.left + (containerGeom.size.width / 2);

  return {
    left: midPoint - elmShift,
    top: elmGeom.offset.top
  };
};

const alignRight = (containerGeom, elmGeom) => {
  return {
    left: containerGeom.offset.left + containerGeom.size.width - elmGeom.size.width,
    top: elmGeom.offset.top
  };
};

const alignTop = (containerGeom, elmGeom) => {
  return {
    left: elmGeom.offset.left,
    top: containerGeom.offset.top
  };
};

const alignVertical = (containerGeom, elmGeom) => {
  const elmShift = elmGeom.size.height / 2;
  const verticalMidPoint = containerGeom.offset.top + (containerGeom.size.height / 2);

  return {
    left: elmGeom.offset.left,
    top: verticalMidPoint - elmShift
  };
};

const alignBottom = (containerGeom, elmGeom) => {
  return {
    left: elmGeom.offset.left,
    top: containerGeom.offset.top + containerGeom.size.height - elmGeom.size.height
  };
};

export default {
  alignLeft,
  alignHorizontally,
  alignRight,
  alignTop,
  alignVertical,
  alignBottom
};


// WEBPACK FOOTER //
// ./src/ui/canvas/calculate-offset.js